var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 11.577,
    viewBox: "0 0 13 11.577",
    width: 13,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    transform: "translate(-8.498 -9.623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.78 10.344a.75.75 0 0 1 0 1.062l-3.97 3.968 3.97 3.969a.751.751 0 0 1 -1.062 1.057l-4.5-4.5a.75.75 0 0 1 0-1.062l4.5-4.5a.75.75 0 0 1 1.062 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.125 17.625a.75.75 0 0 1 .75-.75h9.749a.75.75 0 1 1 0 1.5h-9.749a.75.75 0 0 1 -.75-.75z",
    transform: "translate(-.376 -2.251)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftShort);
export default __webpack_public_path__ + "static/media/arrow-left-short.fb40c770a6857e41c40206eef0f9b85f.svg";
export { ForwardRef as ReactComponent };